import {RefObject, useRef, useState} from "react";

import {
    HomeMatchAmplitudeLocation,
    HomeMatchAmplitudeTracker,
    HomeMatchPreferencesWizardAmplitudeButton
} from "@/features/tracking/amplitude/home_match_amplitude_tracker";
import {useRegisteredSubmit} from "@/hooks/use_registered_submit";

import {HomeMatchPreferencesWizardStep} from "../../utils/get_home_match_preferences_wizard_steps";

const {PHONE, SMS} = HomeMatchPreferencesWizardStep;

interface IParams {
    amplitudeLocation: HomeMatchAmplitudeLocation;
    onAdvance: () => void;
    onClose: () => void;
    onDone: () => void;
    phone: string | null;
    saveInFlightRef: RefObject<boolean>;
    trackSaved: (savedStep: HomeMatchPreferencesWizardStep) => void;
}

export const useHomeMatchPreferencesWizardPhone = (params: IParams) => {
    const {amplitudeLocation, onAdvance, onClose, onDone, phone, saveInFlightRef, trackSaved} = params;
    const [verifiedPhone, setVerifiedPhone] = useState(phone);
    const [isChanging, setIsChanging] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [canConfirmSms, setCanConfirmSms] = useState(false);
    const [smsSessionKey, setSmsSessionKey] = useState(0);
    const phoneSavedRef = useRef(false);
    const shouldSavePhoneRef = useRef(false);
    const phoneSubmit = useRegisteredSubmit();
    const smsSubmit = useRegisteredSubmit();

    const reset = () => {
        setVerifiedPhone(phone);
        setIsChanging(false);
        shouldSavePhoneRef.current = false;
    };

    const submit = (visibleStep: HomeMatchPreferencesWizardStep) => (visibleStep === SMS ? smsSubmit : phoneSubmit).submit();

    const onPhoneSaved = (savedPhone: string) => {
        const shouldSavePhone = shouldSavePhoneRef.current;
        const wasChanging = isChanging;

        shouldSavePhoneRef.current = false;
        phoneSavedRef.current = true;
        setVerifiedPhone(savedPhone);
        setIsChanging(false);

        if (shouldSavePhone) {
            trackSaved(PHONE);
            return onClose();
        }

        if (wasChanging) return setSmsSessionKey((key) => key + 1);

        onAdvance();
    };

    const savePhoneAndClose = async () => {
        saveInFlightRef.current = true;
        shouldSavePhoneRef.current = true;
        phoneSavedRef.current = false;

        try {
            await phoneSubmit.submit();

            if (!phoneSavedRef.current) shouldSavePhoneRef.current = false;
        } finally {
            saveInFlightRef.current = false;
        }
    };

    const closeSms = () => {
        trackSaved(SMS);
        HomeMatchAmplitudeTracker.preferencesWizardPhoneVerified(false, amplitudeLocation);
        onClose();
    };

    const closeChange = () => {
        HomeMatchAmplitudeTracker.preferencesWizardClick(HomeMatchPreferencesWizardAmplitudeButton.BACK, PHONE, amplitudeLocation);
        setIsChanging(false);
    };

    const changeSmsNumber = () => {
        HomeMatchAmplitudeTracker.preferencesWizardClick(HomeMatchPreferencesWizardAmplitudeButton.CHANGE_PHONE, SMS, amplitudeLocation);
        setIsChanging(true);
    };

    const trackSmsResend = () => {
        HomeMatchAmplitudeTracker.preferencesWizardClick(HomeMatchPreferencesWizardAmplitudeButton.RESEND, SMS, amplitudeLocation);
    };

    const completeSmsVerification = () => {
        HomeMatchAmplitudeTracker.preferencesWizardPhoneVerified(true, amplitudeLocation);
        onDone();
    };

    return {
        canConfirmSms,
        closeSms,
        isChanging,
        isSubmitting,
        phone: {
            closeChange,
            isChanging,
            isSubmitting,
            onSaved: onPhoneSaved,
            registerSubmit: phoneSubmit.registerSubmit,
            setIsSubmitting
        },
        reset,
        savePhoneAndClose,
        sms: {
            changeNumber: changeSmsNumber,
            onResend: trackSmsResend,
            onSuccess: completeSmsVerification,
            registerSubmit: smsSubmit.registerSubmit,
            sessionKey: smsSessionKey,
            setCanConfirm: setCanConfirmSms,
            verifiedPhone
        },
        stopChanging: () => setIsChanging(false),
        submit
    };
};
import {RefObject, useRef, useState} from "react";

import {
    HomeMatchAmplitudeLocation,
    HomeMatchAmplitudeTracker,
    HomeMatchPreferencesWizardAmplitudeButton
} from "@/features/tracking/amplitude/home_match_amplitude_tracker";
import {useRegisteredSubmit} from "@/hooks/use_registered_submit";

import {HomeMatchPreferencesWizardStep} from "../../utils/get_home_match_preferences_wizard_steps";

const {PHONE, SMS} = HomeMatchPreferencesWizardStep;

interface IParams {
    amplitudeLocation: HomeMatchAmplitudeLocation;
    onAdvance: () => void;
    onClose: () => void;
    onDone: () => void;
    phone: string | null;
    saveInFlightRef: RefObject<boolean>;
    trackSaved: (savedStep: HomeMatchPreferencesWizardStep) => void;
}

export const useHomeMatchPreferencesWizardPhone = (params: IParams) => {
    const {amplitudeLocation, onAdvance, onClose, onDone, phone, saveInFlightRef, trackSaved} = params;
    const [verifiedPhone, setVerifiedPhone] = useState(phone);
    const [isChanging, setIsChanging] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [canConfirmSms, setCanConfirmSms] = useState(false);
    const [smsSessionKey, setSmsSessionKey] = useState(0);
    const phoneSavedRef = useRef(false);
    const shouldSavePhoneRef = useRef(false);
    const phoneSubmit = useRegisteredSubmit();
    const smsSubmit = useRegisteredSubmit();

    const reset = () => {
        setVerifiedPhone(phone);
        setIsChanging(false);
        shouldSavePhoneRef.current = false;
    };

    const submit = (visibleStep: HomeMatchPreferencesWizardStep) => (visibleStep === SMS ? smsSubmit : phoneSubmit).submit();

    const onPhoneSaved = (savedPhone: string) => {
        const shouldSavePhone = shouldSavePhoneRef.current;
        const wasChanging = isChanging;

        shouldSavePhoneRef.current = false;
        phoneSavedRef.current = true;
        setVerifiedPhone(savedPhone);
        setIsChanging(false);

        if (shouldSavePhone) {
            trackSaved(PHONE);
            return onClose();
        }

        if (wasChanging) return setSmsSessionKey((key) => key + 1);

        onAdvance();
    };

    const savePhoneAndClose = async () => {
        saveInFlightRef.current = true;
        shouldSavePhoneRef.current = true;
        phoneSavedRef.current = false;

        try {
            await phoneSubmit.submit();

            if (!phoneSavedRef.current) shouldSavePhoneRef.current = false;
        } finally {
            saveInFlightRef.current = false;
        }
    };

    const closeSms = () => {
        trackSaved(SMS);
        HomeMatchAmplitudeTracker.preferencesWizardPhoneVerified(false, amplitudeLocation);
        onClose();
    };

    const closeChange = () => {
        HomeMatchAmplitudeTracker.preferencesWizardClick(HomeMatchPreferencesWizardAmplitudeButton.BACK, PHONE, amplitudeLocation);
        setIsChanging(false);
    };

    const changeSmsNumber = () => {
        HomeMatchAmplitudeTracker.preferencesWizardClick(HomeMatchPreferencesWizardAmplitudeButton.CHANGE_PHONE, SMS, amplitudeLocation);
        setIsChanging(true);
    };

    const trackSmsResend = () => {
        HomeMatchAmplitudeTracker.preferencesWizardClick(HomeMatchPreferencesWizardAmplitudeButton.RESEND, SMS, amplitudeLocation);
    };

    const completeSmsVerification = () => {
        HomeMatchAmplitudeTracker.preferencesWizardPhoneVerified(true, amplitudeLocation);
        onDone();
    };

    return {
        canConfirmSms,
        closeSms,
        isChanging,
        isSubmitting,
        phone: {
            closeChange,
            isChanging,
            isSubmitting,
            onSaved: onPhoneSaved,
            registerSubmit: phoneSubmit.registerSubmit,
            setIsSubmitting
        },
        reset,
        savePhoneAndClose,
        sms: {
            changeNumber: changeSmsNumber,
            onResend: trackSmsResend,
            onSuccess: completeSmsVerification,
            registerSubmit: smsSubmit.registerSubmit,
            sessionKey: smsSessionKey,
            setCanConfirm: setCanConfirmSms,
            verifiedPhone
        },
        stopChanging: () => setIsChanging(false),
        submit
    };
};
